import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { getDashboard, type DashboardParams } from '@/api/dashboard'

export function useDashboard(params: DashboardParams) {
  return useQuery({
    // Prefix ['dashboard'] stays first so the existing invalidations (deal saves, moves) still hit it.
    queryKey: ['dashboard', params.period, params.ownerId ?? null, params.pipelineId ?? null],
    queryFn: () => getDashboard(params),
    // Keep the current numbers on screen while a filter change loads, instead of flashing "Loading…".
    placeholderData: keepPreviousData,
  })
}
